<template>
    <div>
        <div id="app">
            <span class="account-options container" v-show="$auth.check() && checkRoute()">
                <!--<router-link :to="{name: 'dashboard'}">account</router-link> &bull;-->
                <a class="btn" v-on:click="logout()" href="javascript:void(0);">Log Out</a>
            </span>
            <div v-if="$auth.ready()">
                <notifications group="notifications" position="bottom right" />
                <router-view></router-view>
            </div>            
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import Quotation from './views/Quotation.vue'
import {RotateSquare2} from 'vue-loading-spinner';

export default {
  name: 'app',
  components: {
    Login,
    Register,
    Quotation,
    RotateSquare2
  },
  data() {
      return {
          context: 'app context',
          loaded: false
      };
  },
  mounted() {
      var _this = this;
      // Set up $auth.ready with other arbitrary loaders (ex: language file).
      setTimeout(function () {
          _this.loaded = true;
      }, 500);
  },
  created() {
      var _this = this;
      var email = this.$cookie.get("user")
      if(email){
        this.$auth.user({email: email})
      }else if(this.$auth.check()){
          this.logout()
      }
  },
  methods: {
      logout() {
          this.$cookie.delete('user');
          this.$auth.logout({
              makeRequest: false,
              success() {
                  window.location.href = '/';
              }
          });
      },
      checkRoute() {
          let showLogout = true;
          this.$router.options.routes.forEach(route => {
              let path = route.path.replace(/\//g, '');
              let pathToCompare = window.location.pathname.replace(/\//g, '');
              if(path == pathToCompare){
                showLogout = route.meta.auth == false ?  false : true;
              }
          });
          return showLogout; 
      }
  }
}
</script>
